import React from "react";

/**
 * TeaserSection — a titled band for value-prop rows / sample-card groups.
 *
 * Props:
 *   eyebrow?    node
 *   title?      node   section heading (H2)
 *   subtitle?   node
 *   align?      "start" | "center"  default "start"
 *   id?         str
 *   className?  str
 *   children    node
 */
const TeaserSection = ({
  eyebrow,
  title,
  subtitle,
  align = "start",
  id,
  className = "",
  children,
}) => {
  return (
    <section
      id={id}
      className={
        "teaser-section" +
        ` teaser-section--${align}` +
        (className ? ` ${className}` : "")
      }
    >
      {(eyebrow || title || subtitle) && (
        <header className="teaser-section__head">
          {eyebrow ? <span className="teaser-eyebrow">{eyebrow}</span> : null}
          {title ? <h2 className="teaser-section__title">{title}</h2> : null}
          {subtitle ? (
            <p className="teaser-section__sub">{subtitle}</p>
          ) : null}
        </header>
      )}
      {children}
    </section>
  );
};

export default TeaserSection;
